import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '@/views/Playground/HomePlayground.vue'
import HomeWebChat from '@/views/WebChat/HomeWidget.vue'
import HomeWebChatFull from '@/views/WebChatFull/HomeWebChatFull.vue'
import HomeWebChatJsFull from '@/views/WebChatFull/HomeJs.vue'
import HomeInternalChat from '@/views/InternChat/HomeBox.vue'
import InternalChatJs from '@/views/InternChat/HomeJs.vue'
import HomeInternalChatFull from '@/views/InternChatFull/HomeBox.vue'
import NotFound from '@/views/NotFound.vue'
import NotifyHome from '@/views/Notify/HomeNotify.vue'
import AuditHome from '@/views/Audit/HomeAudit.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/webchat',
    name: 'WebChat',
    component: HomeWebChat
  },
  {
    path: '/web-chat-full',
    name: 'WebChatFull',
    component: HomeWebChatFull
  },
  {
    path: '/web-chat-js',
    name: 'WebChatJs',
    component: HomeWebChatJsFull
  },
  {
    path: '/chat-interno',
    name: 'chat.internal',
    component: HomeInternalChat,
    meta: { title: 'Chat Interno' }
  },
  {
    path: '/chat-interno-js',
    name: 'chat.internal.js',
    component: InternalChatJs,
    meta: { title: 'Chat Interno' }
  },
  {
    path: '/chat-interno-full',
    name: 'chat.internal.full',
    component: HomeInternalChatFull,
    meta: { title: 'Chat Interno' }
  },
  {
    path: '/auditoria',
    name: 'audit.home',
    component: AuditHome,
    meta: { title: 'Auditoria' }
  },
  {
    path: '/notificacao',
    name: 'notify.home',
    component: NotifyHome,
    meta: { title: 'Notificações' }
  },
  {
    path: '/:catchAll(.*)',
    component: NotFound,
    name: 'NotFound',
    meta: { title: 'Página não encontrada!' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  next()
})

export default router
